export default [
  {
    active: "info",
    actionKey: "ak",
    name: "Ryan Schley",
    image: "img/board/ryan.png",
    role: "President",
    email: "schley.20@buckeyemail.osu.edu",
    bio: `How could we ever trust a system we don't understand?`,
    quote: `"What is it that we value?" Wit whispered. "Innovation. Originality. Novelty. But most importantly... timeliness." - Brandon Sanderson`,
    linkedin: "https://www.linkedin.com/in/ryan-schley-7a849429b/",
    github: "https://github.com/Ryflin",
  },
  {
    active: "info",
    actionKey: "js",
    name: "Henry Trowbridge",
    image: "img/board/henry.png",
    role: "Vice President",
    email: "Trowbridge.47@buckeyemail.osu.edu",
    bio: `Let The Peace Of The Great 禪 And 道 And 義 And 學 and 德 Bring You Solace, Oh Great And Unmatched Chungus One.`,
    quote: `"天下之人甚同也" - Anonymous`,
    linkedin: "https://www.linkedin.com/in/henry1679/",
    github: "https://github.com/henry7720/",
  },
  {
    active: "info",
    actionKey: "bt",
    name: "Tran Nguyen",
    image: "img/board/tran-nguyen.webp",
    role: "Treasurer",
    email: "nguyen.3074@buckeyemail.osu.edu",
    bio: `Meow :)`,
    quote: `"This world is but a canvas to our imagination." - Thoreau`,
    linkedin: "https://www.linkedin.com/in/tran-nguyen3074",
    github: "https://github.com",
  },
];
